
var totalItems = 0;
var totalCost = 0;

function addToCart(input) {
	var quantity = parseInt(input.value);
	var variantId = input.getAttribute('data-variant-id');
}

function updateTotals(input) {
	// Disable input for half a second to prevent quick multiple clicks
	input.addEventListener('click', function(event) {
		if (event.target.classList.contains('quantity-selector__button')) {
			input.disabled = true;
			setTimeout(function() {
				input.disabled = false;
			}, 200);
		}
	});

	var maxQuantity = parseInt(input.getAttribute('data-max-quantity')) || 0; // If max quantity is empty or 0, set maxQuantity to 0
	var quantity = parseInt(input.value) || 0; // If input is empty or 0, set quantity to 0
	if (quantity > maxQuantity) {
		quantity = maxQuantity;
		input.value = maxQuantity;
		alert('You have added more items then are available. Your quantity will be automatically adjusted.');
	}
	if (quantity === 0) {
		input.value = '';
	}
	var variantId = input.getAttribute('data-variant-id');
	var price = parseFloat(input.getAttribute('data-variant-price'));
	var currencySymbol = window.theme.moneyFormat;
	var currencySymbolFormatted = currencySymbol.replace('{amount}', '').replace('{}', '').replace('{amount_with_comma_separator}', '').replace('{}', '');

	var oldQuantity = input.getAttribute('data-old-quantity') ? parseInt(input.getAttribute('data-old-quantity')) : 0;
	totalItems = totalItems - oldQuantity + quantity;
	totalCost = totalCost - (oldQuantity * price) + (quantity * price);

	if (totalItems > 1 ) {
		document.querySelector('.js-atc-item-count').innerText = totalItems;
		document.querySelector('.js-atc-item-suffix').innerText = window.languages.productFormATCItemSuffixPlural;
		document.querySelector('#clearAll').classList.remove('hidden'); 
		document.querySelector('.js-quick-multibuy-submit').removeAttribute('disabled');
	} else if (totalItems === 1 ) {
		document.querySelector('.js-atc-item-count').innerText = totalItems;
		document.querySelector('.js-atc-item-suffix').innerText = window.languages.productFormATCItemSuffixSingular;
		document.querySelector('#clearAll').classList.remove('hidden'); 
		document.querySelector('.js-quick-multibuy-submit').removeAttribute('disabled');
	} else {
		document.querySelector('.js-atc-item-count').innerText = '';
		document.querySelector('.js-atc-item-suffix').innerText = '';
		document.querySelector('#clearAll').classList.remove('hidden'); 
	}

	document.querySelector('.js-quick-multibuy-submit-price').classList.remove('hidden');
	document.querySelector('.js-quick-multibuy-submit-price').innerText = currencySymbolFormatted + (totalCost / 100).toFixed(2);

	input.setAttribute('data-old-quantity', quantity);

	if (totalItems == 0) {
			document.querySelector('.js-quick-multibuy-submit-price').classList.add('hidden');
	}
}

document.querySelectorAll('.js-quantity-selector__value').forEach(function(input) {
	input.addEventListener('change', function () {
		if (input.value === '' || input.value === '0') { // If input is empty or 0, set it to blank
			input.value = '';
		}
		updateTotals(input);
		var variantSku = input.getAttribute('data-variant-sku');
		document.querySelector('.product-meta__sku-number').innerText = variantSku;
	});
	input.addEventListener('keyup', function() { // Update totals when user types in input
		updateTotals(input);
		var variantSku = input.getAttribute('data-variant-sku');
		document.querySelector('.product-meta__sku-number').innerText = variantSku;
	});
});

document.querySelector('.js-quick-multibuy-submit').addEventListener('click', function () {
	this.setAttribute('disabled', 'disabled');
	this.querySelector('.loading-overlay').classList.remove('hidden');
	this.querySelector('.button-text').classList.add('hidden');
	this.querySelector('.button-price').classList.add('hidden');

	var inputs = document.querySelectorAll('.quantity-selector__value');
	inputs.forEach(function(input) {
		addToCart(input);
	});
	
	fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({
			items: Array.from(inputs).map(function(input) {
				var id = input.getAttribute('data-variant-id');
				var quantity = parseInt(input.value);
				if(id && quantity) {
					return {
						id: id,
						quantity: quantity
					};
				}
			})
		})
	})
	.then(function() {
		updateMiniCart();
		document.querySelector('.loading-overlay').classList.add('hidden');
		document.querySelector('.button-text').classList.remove('hidden');
		document.querySelector('.button-price').classList.remove('hidden');

		var spanElement = document.createElement('span');
		var buttonTextElement = document.querySelector('.button-text');

		spanElement.classList.add('product-form__add-button--added');
		spanElement.innerText = window.languages.productFormAddedToCart;
		buttonTextElement.parentNode.insertBefore(spanElement, buttonTextElement);
		buttonTextElement.classList.add('hidden');
		document.querySelector('.button-price').classList.add('hidden');

		setTimeout(function() {
			spanElement.classList.add('hidden');
			buttonTextElement.classList.remove('hidden');
			document.querySelector('.button-price').classList.remove('hidden');
			document.querySelector('.product-form__add-button--added').remove;
			document.querySelector('.js-quick-multibuy-submit').removeAttribute('disabled');
			document.querySelector('.modal__close').click();
			setTimeout(function() {
				document.querySelector('.header__cart-toggle').click();
			}, 800);
		}, 1000);
	})
	.then(data => console.log(data))
	.catch((error) => {
		console.error('Error:', error);
		document.querySelector('.loading-overlay').classList.add('hidden');
		document.querySelector('.button-text').classList.remove('hidden');
		document.querySelector('.button-price').classList.remove('hidden');
	});
});

function updateMiniCart() {
	fetch('/?sections=mini-cart')
		.then(response => response.text())
		.then(data => {
			let parsedData = JSON.parse(data);
			let nestedObject = parsedData['mini-cart'];
			document.querySelector('#mini-cart').innerHTML = nestedObject;
			updateCartCount();
		})
		.catch((error) => {
		console.error('Error:', error);
	});
}

function updateCartCount() {
	fetch('/cart.js')
	.then(response => response.json())
	.then(data => {
		document.querySelector('#cart-icon-bubble').querySelector('.header__cart-count').innerHTML = data.item_count;
	})
	.catch((error) => {
		console.error('Error:', error);
	});
}

document.getElementById('clearAll').addEventListener('click', function() {
	var inputs = document.querySelectorAll('.quantity-selector__value');
	var currencySymbol = window.theme.moneyFormat;
	var currencySymbolFormatted = currencySymbol.replace('{amount}', '').replace('{}', '').replace('{amount_with_comma_separator}', '').replace('{}', '');

	inputs.forEach(function(input) {
		input.value = '';
	});
	totalItems = 0;
	totalCost = 0;
	document.getElementById('totalItems').innerText = 0;
	document.querySelector('.js-atc-item-count').innerText = '';
	document.querySelector('.js-atc-item-suffix').innerText = '';
	document.querySelector('.js-quick-multibuy-submit-price').innerText = '';
	document.querySelector('.js-quick-multibuy-submit-price').classList.add('hidden');
	inputs.forEach(function(input) {
		input.removeAttribute('data-old-quantity');
	});
	document.querySelector('#clearAll').classList.add('hidden'); 
});